import { Alert, ErrorPage } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

type ErrorPageProps = {
  technicalError?: string;
  type?: number;
  startPageLinkUrl?: string;
};

export const EmployerMyPagesErrorPage = ({ technicalError, type, startPageLinkUrl }: ErrorPageProps) => {
  const { t } = useTypedTranslation();
  const ErrorPageContent = () => {
    switch (type) {
      case 401:
        return (
          <ErrorPage
            type={type}
            title={t('errorMessages.401Page.title')}
            message={t('errorMessages.401Page.message')}
            links={[
              {
                linkText: t('common.loginToMyPages'),
                linkUrl: 'https://internetkontoret.fora.se/irj/portal/Foretag',
              },
            ]}
          />
        );
      case 404:
        return (
          <ErrorPage
            type={type}
            title={t('errorMessages.404Page.title')}
            message={t('errorMessages.404Page.message')}
            links={[
              ...(startPageLinkUrl
                ? [
                    {
                      linkText: t('common.toStartPage'),
                      linkUrl: startPageLinkUrl,
                    },
                  ]
                : []),
              {
                linkText: t('common.contactFora'),
                linkUrl: 'https://www.fora.se/kundservice-foretag',
              },
            ]}
          />
        );
      case 500:
        return (
          <ErrorPage
            type={type}
            title={t('errorMessages.generic.title')}
            message={t('errorMessages.500Page.message')}
          />
        );
      case 503:
        return (
          <ErrorPage
            type={type}
            title={t('errorMessages.underMaintenance.title')}
            message={t('errorMessages.underMaintenance.description')}
            links={[
              {
                linkText: t('common.loginToMyPages'),
                linkUrl: 'https://internetkontoret.fora.se/irj/portal/Foretag',
              },
            ]}
          />
        );
      default:
        return <ErrorPage />;
    }
  };

  return (
    <>
      <ErrorPageContent />
      {technicalError && <Alert variant="danger">{technicalError}</Alert>}
    </>
  );
};
